import React, { useRef } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import './ScreenshotsAndExtraFiles.css';
import { isEmpty } from '../../../Utils/helpers';

function ScreenshotsAndExtraFiles({
  screenshots,
  extraFiles,
  onClickScreenshots,
}) {
  screenshots = screenshots || [];
  extraFiles = extraFiles || [];
  const op = useRef(null);

  const panelContent = (
    <div className='extra-files-popover'>
      <span className='extra-files-popover-title'>Extra Files</span>
      {extraFiles.map((ef) => (
        <a key={ef.file.url} href={ef.file.url} download>
          {ef.file.fileName}
        </a>
      ))}
    </div>
  );

  return (
    <div className='inline-flex-container extra-files-container'>
      {!isEmpty(screenshots) && (
        <span
          className='e-icons e-image'
          onClick={(e) => {
            return onClickScreenshots(screenshots[0].url, e);
          }}
        />
      )}
      {!isEmpty(extraFiles) && (
        <>
          <span
            className='e-icons e-folder extra-files-icon'
            onClick={(e) => {
              e.stopPropagation();
              op.current.toggle(e);
            }}
          />
          <OverlayPanel ref={op} className='extra-files-panel' showCloseIcon>
            {panelContent}
          </OverlayPanel>
        </>
      )}
    </div>
  );
}

export default ScreenshotsAndExtraFiles;
